import { atom } from "jotai";

export const numParamsAtom = atom<number>(20);
export const corrCutOffAtom = atom<number>(0.0);
export const showLabelsAtom = atom<boolean>(true);
